export default {
      id: "group-usage",
      viewBox: "0 0 47 38",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#group",
      toString: function () {
        return this.url;
      }
    }